// extracted by mini-css-extract-plugin
export default {"title":"cjskbyJK","detail":"HIwk5NTZ","button":"lOpKBExW","content":"mLsBfsVh","warning":"eHea9B63"};